import React, { useState, useEffect, useMemo } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import {
  getTimeFormatPreference,
  setTimeFormatPreference,
  getDefaultDriverPreference,
  setDefaultDriverPreference,
} from "../../../utils/preferences";

export default function Preferences() {
  const [timeFormat, setTimeFormat] = useState<"seconds" | "minutes">(
    getTimeFormatPreference(),
  );
  const [defaultDriver, setDefaultDriver] = useState<string | null>(
    getDefaultDriverPreference(),
  );

  useEffect(() => {
    setTimeFormatPreference(timeFormat);
  }, [timeFormat]);

  useEffect(() => {
    setDefaultDriverPreference(defaultDriver);
  }, [defaultDriver]);

  const jagDrivers = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.jagDrivers,
    isEqual,
  );
  const driverInfo = useSelector(
    (state: RootState) => state.imports.derivedImportData.strategy.driverInfo,
    isEqual,
  );

  const driverOptions = useMemo(() => {
    return Object.entries(jagDrivers)
      .filter(([, driverId]) => driverId)
      .map(([carKey, driverId]) => {
        const driver = driverId ? driverInfo[driverId] : undefined;
        return {
          value: carKey,
          label: driver?.driverName || carKey,
          colour: driver?.driverHighlightColourAlt || "#888",
        };
      });
  }, [jagDrivers, driverInfo]);

  return (
    <div className={styles.container}>
      <div className={styles.preferenceContainer}>
        <div className={styles.header}>Time Format</div>
        <div className={styles.section}>
          <label className={styles.radioLabel}>
            <input
              type="radio"
              name="timeFormat"
              value="seconds"
              checked={timeFormat === "seconds"}
              onChange={() => setTimeFormat("seconds")}
            />
            Seconds (89.365)
          </label>
          <label className={styles.radioLabel}>
            <input
              type="radio"
              name="timeFormat"
              value="minutes"
              checked={timeFormat === "minutes"}
              onChange={() => setTimeFormat("minutes")}
            />
            Minutes (1:29.365)
          </label>
        </div>
      </div>
      <div className={styles.preferenceContainer}>
        <div className={styles.header}>Default Driver</div>
        <div className={styles.section}>
          {driverOptions.map((driver) => (
            <label key={driver.value} className={styles.radioLabel}>
              <input
                type="radio"
                name="defaultDriver"
                value={driver.value}
                checked={defaultDriver === driver.value}
                onChange={() => setDefaultDriver(driver.value)}
              />
              <span style={{ color: driver.colour, fontWeight: "bold" }}>
                {driver.label}
              </span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
